module.exports = __webpack_public_path__ + "img/fangda.8221821e.png";